import { useInstance } from '../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { HistoryViewModel } from '../app/HistoryViewModel.ts';
import { Page } from '../components/page/Page.tsx';
import { useEditableMissionState } from '../missions/model/useEditableMissionState.tsx';
import { OperatorState } from '../profile/OperatorState.ts';
import { DevSettings } from '../support/DevSettings.ts';
import { usePageView } from '../support/tracking/usePageView.tsx';
import { AuthorizationDetails } from './components/AuthorizationDetails.tsx';

export const MissionAuthorizationDetailsPage: React.FC<{ missionId: string }> = ({ missionId }) => {
    usePageView('Mission LAANC Authorization Details');
    const history = useInstance(HistoryViewModel);

    const missionVM = useEditableMissionState(missionId);
    const operatorState = useInstance(OperatorState);
    useSubscription(() => operatorState);
    const operator = operatorState.state;

    const devSettings = useInstance(DevSettings);

    if (!missionVM) {
        return null;
    }

    const relevantAuthorizations = missionVM.getRelevantAuthorizations();

    return (
        <Page title="Authorization Details" onBack={() => history.back(missionVM.pages.details.path())}>
            <AuthorizationDetails
                mission={missionVM}
                authorizations={relevantAuthorizations}
                operator={operator}
                devSettings={devSettings}
            />
        </Page>
    );
};
